import { render, staticRenderFns } from "./AvailableTimeStudentIndex.vue?vue&type=template&id=42ff3242&"
import script from "./AvailableTimeStudentIndex.vue?vue&type=script&lang=js&"
export * from "./AvailableTimeStudentIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports